export default {
  //TODO: REMOVE AND USE NEW TRANSLATIONS
  AV_SETTINGS: `Configuraciones de audio y video`,
  AV_PREVIEW: `Vista previa de audio y video`,
  SPEAKER_TEST: `Prueba de altavoces`,
  SPEAKER_TEST_HELP_TEXT: `Enviaremos un sonido para comprobar tus altavoces/audífonos. Asegúrate de subir el volumen.`,
  SPEAKER_TEST_CTA: `Prueba tus altavoces`,
  CHOOSE_DEVICES_HEADER: `Elige la cámara, micrófono y altavoz/audífono para esta llamada:`,
  MIC_INPUT_LABEL: `Micrófono`,
  VIDEO_INPUT_LABEL: `Video`,
  MICROPHONE_SOUND_LEVEL: `Nivel de sonido del micrófono`,
  CLOSE: `Cerrar`,
  NONE: `Ninguno`,

  // NEW TRANSLATIONS
  DEVICE_SETTINGS_MODAL_HEADER: `Configuraciones`,
  DEVICE_SETTINGS_TAB_SETTINGS: `Configuración de dispositivo`,
  DEVICE_SETTINGS_TAB_HELP: `Ayuda`,
  DEVICE_SETTINGS_SPEAKER_SELECTION_LABEL: `Selecciona tus altavoces`,
  DEVICE_SETTINGS_SPEAKER_TEST_BUTTON: `Prueba de sonido`,
  DEVICE_SETTINGS_MICROPHONE_SELECTION_LABEL: `Selecciona tu micrófono`,
  DEVICE_SETTINGS_CAMERA_SELECTION_LABEL: `Selecciona tu cámara`,
  DEVICE_SETTINGS_BACK_TO_CALL_BUTTON: `Regresa a la llamada`,
  DEVICE_SETTINGS_HELP_BUTTON: `Necesito ayuda`,

  DEVICE_SETTINGS_DROPDOWN_ERROR_PLACEHOLDER: `- Seleccionar -`,
  DEVICE_SETTINGS_SPEAKER_ERROR_ALERT: `Selecciona un altavoz para proceder.`,
  DEVICE_SETTINGS_MICROPHONE_ERROR_ALERT: `Selecciona un micrófono para proceder.`,
  DEVICE_SETTINGS_CAMERA_ERROR_ALERT: `Selecciona una entrada de cámara para proceder.`,

  DEVICE_SETTINGS_AUDIO_ONLY_OPTION_FOR_CAMERA_DROPDOWN: `Únete a la llamada solo por audio`,
  DEVICE_SETTINGS_SAFARI_SPEAKER_ERROR_ALERT: `Selecciona un altavoz diferente para proceder.`,
  DEVICE_SETTINGS_DROPDOWN_AUTO_DETECTED: `- Detectado automáticamente -`,

  PICK_SOUND_OUTPUT_DEVICE: `Selecciona el dispositivo de salida de sonido`,
  CHOOSE_YOUR_CAMERA: `Selecciona el dispositivo de entrada de la cámara`,
  CHOOSE_YOUR_MICROPHONE: `Selecciona el dispositivo de entrada del micrófono`,

  DEVICE_SETTINGS_DEFAULT: `Predeterminado`,
  DEVICE_SETTINGS_VIDEO_QUALITY: `Calidad de video`,

  // footer
  FOOTER_A11Y_STATEMENT: `Declaración de Accesibilidad`,
};
